import React, { useState, useEffect, useContext } from "react";
import Swal from "sweetalert2";
import {
  Table,
  Form,
  Col,
  Row,
  Button,
  Container,
  Badge,
  Dropdown,
  Tabs,
  Tab,
} from "react-bootstrap";
import {
  BiMenu,
  BiUpload,
  BiDownload,
  BiSearch,
  BiLinkExternal,
} from "react-icons/bi";
import * as XLSX from "xlsx";
import SpinnerComponent from "../layout/spinner";
import { get, post, construirMensaje } from "../../helpers/apiHttp";
import { Datarestapi } from "../../context/Datarestapi";
import { useNavigate } from "react-router-dom";

import RegistrarIdentificacion from "./RegistrarIdentificacion";
import RegistrarGuia from "./RegistrarGuia";
import RegistrarUbicacionColombia from "./RegistrarUbicacionColombia";
import RegistrarUbicacionPanama from "./RegistrarUbicacionPanama";

function GestionarOrdenesMasivas() {
  const urlcontext = useContext(Datarestapi);
  const history = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [opcionesSelect, setOpcionesSelect] = useState([]);
  const [ordenesExcel, setOrdenesExcel] = useState([]);
  const [orders, setOrders] = useState([]);
  const [erroresArchivo, setErroresArchivo] = useState([]);
  const [order, setOrder] = useState(null);
  const [ordenesSeleccionadas, setOrdenesSeleccionadas] = useState({});

  const [tipoConsulta, setTipoConsulta] = useState("individual");
  const [serieIndividual, setSerieIndividual] = useState("");
  const [orderNumberIndividual, setOrderNumberIndividual] = useState("");

  const [erpOrdenesSet, setErpOrdenesSet] = useState(new Set());
  const [erpOrdenesAnuladasSet, setErpOrdenesAnuladasSet] = useState(new Set());
  const [erpResumen, setErpResumen] = useState({
    archivo: "",
    totalOrdenes: 0,
    encontradas: 0,
    anuladasEncontradas: 0,
  });

  const [show, setShow] = useState(false);
  const [showguia, setShowguia] = useState(false);
  const [showUbicacionCO, setShowUbicacionCO] = useState(false);
  const [showUbicacionPA, setShowUbicacionPA] = useState(false);

  const handleClose = () => setShow(false);
  const handleCloseguia = () => setShowguia(false);
  const handleCloseUbicacionCO = () => setShowUbicacionCO(false);
  const handleCloseUbicacionPA = () => setShowUbicacionPA(false);

  const [archivoMasivoNombre, setArchivoMasivoNombre] = useState("");
  const [archivoErpNombre, setArchivoErpNombre] = useState("");

  const [filtroNoOrden, setFiltroNoOrden] = useState("");
  const [filtroEstadoBackend, setFiltroEstadoBackend] = useState("");

  useEffect(() => {
    fetchOpcionesSelect();
  }, []);

  const getEstadoBackendNombre = (item) => {
  return (
    item?.data?.nombre_status ||
    item?.data?.estadoBackend ||
    item?.data?.status_name ||
    item?.data?.status_id ||
    "N/A"
  );
};

const estadosBackendDisponibles = [
  ...new Set(
    orders
      .map((item) => String(getEstadoBackendNombre(item)).trim())
      .filter((estado) => estado && estado !== "N/A")
  ),
];

const ordersFiltradas = orders.filter((item) => {
  const noOrden = String(item?.order_number || "").toLowerCase();
  const estado = String(getEstadoBackendNombre(item)).trim();

  const cumpleNoOrden =
    !filtroNoOrden ||
    noOrden.includes(filtroNoOrden.toLowerCase());

  const cumpleEstado =
    !filtroEstadoBackend ||
    estado === filtroEstadoBackend;

  return cumpleNoOrden && cumpleEstado;
});

  const fetchOpcionesSelect = async () => {
    try {
      setIsLoading(true);
      const data = await get("tiendas");
      setIsLoading(false);

      if (data === "401") {
        history("/");
      } else {
        setOpcionesSelect(data.result || []);
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const getTiendaBySerie = (serie) => {
    return opcionesSelect.find(
      (tienda) =>
        String(tienda.prefix || "").trim().toUpperCase() ===
        String(serie || "").trim().toUpperCase()
    );
  };

  const esTiendaPanama = (tiendaId) => {
    return ["9", "11"].includes(String(tiendaId));
  };

  const normalizarValor = (valor) => {
    return String(valor || "").trim();
  };

  const getOrderUniqueKey = (item) => {
    return `${item?.serie || ""}-${item?.order_number || ""}`;
  };

  const normalizarHeader = (value) => {
    return String(value || "")
      .trim()
      .toUpperCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^A-Z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "");
  };

const normalizarOrdenComparacion = (value) => {
  let orderNumber = String(value || "").trim();

  if (!orderNumber) return "";

  orderNumber = orderNumber.replace(/^#/, "");

  // Caso ERP: 60143849 -- ANUL
  if (orderNumber.includes("--")) {
    orderNumber = orderNumber.split("--")[0].trim();
  }

  // Quitar espacios repetidos
  orderNumber = orderNumber.replace(/\s+/g, "");

  return orderNumber;
};

  const esOrdenAnuladaErp = (value) => {
    return String(value || "").toUpperCase().includes("ANUL");
  };

  const isOrdenSeleccionada = (item) => {
    return !!ordenesSeleccionadas[getOrderUniqueKey(item)];
  };

  const toggleOrdenSeleccionada = (item) => {
    const key = getOrderUniqueKey(item);

    setOrdenesSeleccionadas((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const debeMarcarAutomaticamente = (item) => {
    const statusId = Number(item?.data?.status_id);
    return statusId === 7 || statusId === 8;
  };

  const marcarOrdenConErp = (
    item,
    ordenesSet = erpOrdenesSet,
    anuladasSet = erpOrdenesAnuladasSet
  ) => {
    if (!item || !ordenesSet || ordenesSet.size === 0) {
      return item;
    }

    const orderNumber = normalizarOrdenComparacion(item.order_number);
    const existeEnErp = ordenesSet.has(orderNumber);
    const erpAnulada = existeEnErp && anuladasSet.has(orderNumber);

    return {
      ...item,
      existeEnErp,
      erpAnulada,
    };
  };

  const aplicarValidacionErpAOrdenes = (
    ordenes,
    ordenesSet = erpOrdenesSet,
    anuladasSet = erpOrdenesAnuladasSet
  ) => {
    let encontradas = 0;
    let anuladasEncontradas = 0;
    const seleccionadas = {};

    const ordenesActualizadas = ordenes.map((item) => {
      const itemActualizado = marcarOrdenConErp(item, ordenesSet, anuladasSet);

      if (itemActualizado?.existeEnErp) {
        encontradas += 1;
        seleccionadas[getOrderUniqueKey(itemActualizado)] = true;
      }

      if (itemActualizado?.erpAnulada) {
        anuladasEncontradas += 1;
      }

      return itemActualizado;
    });

    return {
      ordenesActualizadas,
      seleccionadas,
      encontradas,
      anuladasEncontradas,
    };
  };

  const consultarOrdenes = async (ordenes) => {
    const formData = new FormData();
    formData.append("ordenes", JSON.stringify(ordenes));

    const data = await post("backend/consultarOrdenesMasivas", formData);

    if (data?.isError === false && data?.statusCode === 200) {
      return data?.result?.result || [];
    }

    throw new Error(
      data?.errorMessage ||
        data?.msj ||
        "No fue posible consultar las órdenes."
    );
  };

  const consultarUnaOrden = async (orderItem) => {
    if (!orderItem) return null;

    const resultados = await consultarOrdenes([
      {
        tienda: orderItem.gbl_id,
        tienda_nombre: orderItem.tienda,
        serie: orderItem.serie,
        order_number: orderItem.order_number,
      },
    ]);

    return resultados[0] || null;
  };

  const agregarOActualizarOrdenEnTabla = (ordenNueva) => {
    if (!ordenNueva) return;

    setOrders((prevOrders) => {
      const keyNueva = getOrderUniqueKey(ordenNueva);

      const existe = prevOrders.some(
        (item) => getOrderUniqueKey(item) === keyNueva
      );

      if (existe) {
        return prevOrders.map((item) =>
          getOrderUniqueKey(item) === keyNueva ? ordenNueva : item
        );
      }

      return [ordenNueva, ...prevOrders];
    });
  };

  const handleConsultarIndividual = async () => {
    const serie = normalizarValor(serieIndividual).toUpperCase();
    const orderNumber = normalizarValor(orderNumberIndividual);

    if (!serie || !orderNumber) {
      construirMensaje(
        "Debe seleccionar una tienda e ingresar el número de orden.",
        "Faltan datos",
        "info"
      );
      return;
    }

    const tiendaEncontrada = getTiendaBySerie(serie);

    if (!tiendaEncontrada) {
      construirMensaje(
        `La serie ${serie} no existe o no está configurada.`,
        "Tienda inválida",
        "warning"
      );
      return;
    }

    try {
      setIsLoading(true);

      const resultados = await consultarOrdenes([
        {
          tienda: tiendaEncontrada.id,
          tienda_nombre: tiendaEncontrada.nombre,
          serie,
          order_number: orderNumber,
        },
      ]);

      setIsLoading(false);

      const resultado = resultados[0] || null;

      if (!resultado) {
        setOrders([]);
        setOrdenesSeleccionadas({});

        construirMensaje(
          "No se encontró información para la orden.",
          "Sin resultados",
          "warning"
        );
        return;
      }

      const resultadoConErp = marcarOrdenConErp(resultado);
      const key = getOrderUniqueKey(resultadoConErp);

      setOrders([resultadoConErp]);

      setOrdenesSeleccionadas(
        resultadoConErp?.existeEnErp ? { [key]: true } : {}
      );

      setOrderNumberIndividual("");

      construirMensaje(
        "Orden consultada correctamente.",
        "Proceso completado",
        "success"
      );
    } catch (error) {
      setIsLoading(false);
      console.error(error);

      construirMensaje(
        error.message || "Error consultando la orden.",
        "Error",
        "error"
      );
    }
  };

  const actualizarFilaOrden = async (orderItem) => {
    try {
      if (!orderItem) return;

      setIsLoading(true);

      const ordenActualizada = await consultarUnaOrden(orderItem);

      setIsLoading(false);

      if (!ordenActualizada) {
        construirMensaje(
          "No fue posible actualizar la información de la orden.",
          "Advertencia",
          "warning"
        );
        return;
      }

      const ordenActualizadaConErp = marcarOrdenConErp(ordenActualizada);
      const key = getOrderUniqueKey(ordenActualizadaConErp);

      if (
        debeMarcarAutomaticamente(ordenActualizadaConErp) ||
        ordenActualizadaConErp?.existeEnErp
      ) {
        setOrdenesSeleccionadas((prev) => ({
          ...prev,
          [key]: true,
        }));
      }

      agregarOActualizarOrdenEnTabla(ordenActualizadaConErp);
      setOrder(ordenActualizadaConErp);
    } catch (error) {
      setIsLoading(false);
      console.error(error);

      construirMensaje(
        "Error actualizando la fila de la orden.",
        "Error",
        "error"
      );
    }
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];

    if (!file) return;
    setArchivoMasivoNombre(file.name);
    setOrders([]);
    setOrdenesExcel([]);
    setErroresArchivo([]);
    setOrdenesSeleccionadas({});

    const reader = new FileReader();

    reader.onload = (event) => {
      try {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        const rows = XLSX.utils.sheet_to_json(worksheet, {
          defval: "",
        });

        if (!rows.length) {
          construirMensaje(
            "El archivo no contiene registros.",
            "Archivo vacío",
            "warning"
          );
          return;
        }

        const errores = [];
        const ordenesValidas = [];

        rows.forEach((row, index) => {
          const fila = index + 2;

          const serie = normalizarValor(row.serie).toUpperCase();
          const orderNumber = normalizarValor(row.order_number);

          if (!serie) {
            errores.push(`Fila ${fila}: falta la serie.`);
          }

          if (!orderNumber) {
            errores.push(`Fila ${fila}: falta el número de orden.`);
          }

          const tiendaEncontrada = getTiendaBySerie(serie);

          if (serie && !tiendaEncontrada) {
            errores.push(`Fila ${fila}: la serie ${serie} no existe.`);
          }

          if (serie && orderNumber && tiendaEncontrada) {
            ordenesValidas.push({
              tienda: tiendaEncontrada.id,
              tienda_nombre: tiendaEncontrada.nombre,
              serie,
              order_number: orderNumber,
            });
          }
        });

        setErroresArchivo(errores);
        setOrdenesExcel(ordenesValidas);

        if (errores.length > 0) {
          Swal.fire({
            icon: "warning",
            title: "Archivo con errores",
            html: errores.slice(0, 15).join("<br>"),
          });
        } else {
          construirMensaje(
            `${ordenesValidas.length} órdenes cargadas correctamente.`,
            "Archivo válido",
            "success"
          );
        }
      } catch (error) {
        console.error(error);
        construirMensaje(
          "No fue posible leer el archivo Excel.",
          "Error",
          "error"
        );
      }
    };

    reader.readAsArrayBuffer(file);
  };

  const handleUploadReporteErp = async (e) => {
    const file = e.target.files[0];

    if (!file) return;

    try {
      setArchivoErpNombre(file.name);
      setIsLoading(true);

      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data, { type: "array" });

      let hojaEncontrada = null;
      let filasHoja = [];
      let headerRowIndex = -1;
      let orderColumnIndex = -1;

      const aliasesColumnaOrden = [
        "NRO_ORDEN_COMPRA",
        "NO_ORDEN_COMPRA",
        "ORDEN_COMPRA",
        "NRO_ORDEN",
        "NO_ORDEN",
        "ORDER_NUMBER",
        "PEDIDO",
      ];

      for (const sheetName of workbook.SheetNames) {
        const worksheet = workbook.Sheets[sheetName];

        const rows = XLSX.utils.sheet_to_json(worksheet, {
          header: 1,
          defval: "",
          blankrows: false,
        });

        for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
          const row = rows[rowIndex] || [];

          const colIndex = row.findIndex((cell) =>
            aliasesColumnaOrden.includes(normalizarHeader(cell))
          );

          if (colIndex !== -1) {
            hojaEncontrada = sheetName;
            filasHoja = rows;
            headerRowIndex = rowIndex;
            orderColumnIndex = colIndex;
            break;
          }
        }

        if (hojaEncontrada) break;
      }

      if (!hojaEncontrada || headerRowIndex === -1 || orderColumnIndex === -1) {
        setIsLoading(false);

        construirMensaje(
          "No se encontró la columna NRO_ORDEN_COMPRA en el reporte ERP.",
          "Archivo ERP inválido",
          "warning"
        );
        return;
      }

      const ordenesSet = new Set();
      const anuladasSet = new Set();

      for (let i = headerRowIndex + 1; i < filasHoja.length; i++) {
        const row = filasHoja[i] || [];
        const rawOrder = row[orderColumnIndex];

        const orderNumber = normalizarOrdenComparacion(rawOrder);

        if (!orderNumber) continue;

        ordenesSet.add(orderNumber);

        if (esOrdenAnuladaErp(rawOrder)) {
          anuladasSet.add(orderNumber);
        }
      }

      if (ordenesSet.size === 0) {
        setIsLoading(false);

        construirMensaje(
          "El reporte ERP no contiene órdenes válidas para validar.",
          "Sin datos",
          "warning"
        );
        return;
      }

      setErpOrdenesSet(ordenesSet);
      setErpOrdenesAnuladasSet(anuladasSet);

      const {
        ordenesActualizadas,
        seleccionadas,
        encontradas,
        anuladasEncontradas,
      } = aplicarValidacionErpAOrdenes(orders, ordenesSet, anuladasSet);

      setOrders(ordenesActualizadas);

      setOrdenesSeleccionadas((prev) => ({
        ...prev,
        ...seleccionadas,
      }));

      setErpResumen({
        archivo: file.name,
        totalOrdenes: ordenesSet.size,
        encontradas,
        anuladasEncontradas,
      });

      setIsLoading(false);

      construirMensaje(
        `Reporte ERP validado correctamente. Órdenes encontradas en la tabla: ${encontradas}.`,
        "Validación ERP completada",
        "success"
      );
    } catch (error) {
      setIsLoading(false);
      console.error(error);

      construirMensaje(
        "No fue posible leer o validar el reporte ERP.",
        "Error",
        "error"
      );
    } finally {
      e.target.value = "";
    }
  };

  const handleConsultarMasivo = async () => {
    if (!ordenesExcel.length) {
      construirMensaje(
        "Debe cargar un archivo Excel válido.",
        "Faltan datos",
        "info"
      );
      return;
    }

    if (erroresArchivo.length > 0) {
      construirMensaje(
        "El archivo tiene errores. Corríjalos antes de consultar.",
        "Archivo inválido",
        "warning"
      );
      return;
    }

    try {
      setIsLoading(true);

      const resultados = await consultarOrdenes(ordenesExcel);

      setIsLoading(false);

      const {
        ordenesActualizadas,
        seleccionadas,
        encontradas,
        anuladasEncontradas,
      } =
        erpOrdenesSet.size > 0
          ? aplicarValidacionErpAOrdenes(
              resultados,
              erpOrdenesSet,
              erpOrdenesAnuladasSet
            )
          : {
              ordenesActualizadas: resultados,
              seleccionadas: {},
              encontradas: 0,
              anuladasEncontradas: 0,
            };

      setOrders(ordenesActualizadas);
      setOrdenesSeleccionadas(seleccionadas);

      if (erpOrdenesSet.size > 0) {
        setErpResumen((prev) => ({
          ...prev,
          encontradas,
          anuladasEncontradas,
        }));
      }

      construirMensaje(
        "La consulta masiva finalizó correctamente.",
        "Proceso completado",
        "success"
      );
    } catch (error) {
      setIsLoading(false);
      setOrders([]);
      setOrdenesSeleccionadas({});
      console.error(error);

      construirMensaje(
        error.message || "No fue posible consultar las órdenes.",
        "Error durante el proceso",
        "error"
      );
    }
  };

  const descargarPlantilla = () => {
    const data = [
      {
        tienda: "Lego Colombia",
        serie: "FEEL",
        order_number: "54544",
      },
    ];

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "ordenes");
    XLSX.writeFile(workbook, "plantilla_consulta_masiva_ordenes.xlsx");
  };

  const handleShow = (orderItem) => {
    setOrder(orderItem);
    setShow(true);
  };

  const handleShowActualizarUbicacion = (orderItem) => {
    setOrder(orderItem);

    if (esTiendaPanama(orderItem?.gbl_id)) {
      setShowUbicacionPA(true);
    } else {
      setShowUbicacionCO(true);
    }
  };

  const handleRestartOrderDescargada = async (orderItem) => {
    const formData = new FormData();

    formData.append("tienda", orderItem.gbl_id);
    formData.append("idorden", orderItem.data.order_id);
    formData.append("backendId", orderItem.data.id);

    try {
      setIsLoading(true);

      const data = await post("backend/restablecerOrdenDecargada", formData);

      setIsLoading(false);

      if (data.isSuccessful === true && data.statusCode === 200) {
        construirMensaje(
          "La orden fue restablecida con éxito",
          "Proceso completado",
          "success"
        );

        await actualizarFilaOrden(orderItem);
      } else {
        construirMensaje(data.errorMessage, "Error durante el proceso", "error");
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const handleCargarOrdenBackend = async (orderItem) => {
    const formData = new FormData();

    formData.append("tienda", orderItem.gbl_id);
    formData.append("idorden", orderItem.data.order_id);

    try {
      setIsLoading(true);

      const data = await post("backend/cargarOrdenbackend", formData);

      setIsLoading(false);

      if (data.isSuccessful === true && data.statusCode === 200) {
        construirMensaje(
          "La orden fue cargada con éxito",
          "Proceso completado",
          "success"
        );

        await actualizarFilaOrden(orderItem);
      } else {
        construirMensaje(data.errorMessage, "Error durante el proceso", "error");
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const statusColor = {
    0: "success",
    1: "danger",
  };

  const hasStatus7or8 = orders.some((item) => {
    const estado = Number(item?.data?.status_id);
    return estado === 7 || estado === 8;
  });

  return (
    <>
      {isLoading ? <SpinnerComponent /> : null}

      <div className="d-flex align-items-center py-2 mb-2 border-bottom">
        <h4 className="mb-0">Gestion Masiva de Órdenes</h4>
      </div>

<Container fluid className="pt-1 mb-2">
  <Tabs
    activeKey={tipoConsulta}
    onSelect={(k) => setTipoConsulta(k)}
    className="mb-3"
  >
    <Tab eventKey="individual" title="Consulta individual">
      <div className="border rounded p-3 bg-light">
        <Row className="align-items-end g-3">
          <Col md={4}>
            {/* <Form.Label>Tienda</Form.Label> */}
            <Form.Select
              value={serieIndividual}
              onChange={(e) => setSerieIndividual(e.target.value)}
            >
              <option value="">Seleccione tienda</option>
              {opcionesSelect.map((tienda) => (
                <option key={tienda.id} value={tienda.prefix}>
                  {tienda.nombre}
                </option>
              ))}
            </Form.Select>
          </Col>

          <Col md={4}>
            {/* <Form.Label>Número de orden</Form.Label> */}
            <Form.Control
              type="text"
              placeholder="Número de orden Ej: 288873 o 288873-01"
              value={orderNumberIndividual}
              onChange={(e) => setOrderNumberIndividual(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleConsultarIndividual();
                }
              }}
            />
          </Col>

          <Col md={4}>
            <Button variant="primary" onClick={handleConsultarIndividual}>
              <BiSearch /> Consultar pedido
            </Button>
          </Col>
        </Row>
      </div>
    </Tab>

    <Tab eventKey="masiva" title="Consulta masiva">
      <div className="border rounded p-3 bg-light">
        <Row className="align-items-center g-3">
          <Col md={3}>
            <Button variant="outline-success" onClick={descargarPlantilla}>
              <BiDownload /> Plantilla
            </Button>
          </Col>

          <Col md={6}>
            <input
              id="archivo-masivo"
              type="file"
              accept=".xlsx,.xls"
              onChange={handleFileUpload}
              style={{ display: "none" }}
            />

            <Button
              variant="outline-secondary"
              onClick={() =>
                document.getElementById("archivo-masivo").click()
              }
            >
              <BiUpload /> Cargar Excel
            </Button>

            <span className="ms-2 text-muted small">
              {archivoMasivoNombre || "Ningún archivo seleccionado"}
            </span>

            {/* <div className="text-muted small mt-1">
              Columnas requeridas: tienda, serie, order_number
            </div> */}
          </Col>

          <Col md={3}>
            <Button
              variant="outline-primary"
              onClick={handleConsultarMasivo}
              disabled={!ordenesExcel.length || erroresArchivo.length > 0}
            >
              <BiSearch /> Consultar órdenes
            </Button>
          </Col>
        </Row>
      </div>
    </Tab>
  </Tabs>
</Container>
{/* {tipoConsulta === "masiva" && ( */}
  <Container fluid className="pt-1 mb-2">
  <div className="border rounded p-3 bg-light">
    <Row className="align-items-center g-3">
      <Col md={3}>
        <strong>Validar contra ERP</strong>
        <div className="text-muted small">
          Columna: NRO_ORDEN_COMPRA
        </div>
      </Col>

      <Col md={4}>
        <input
          id="archivo-erp"
          type="file"
          accept=".xlsx,.xls"
          onChange={handleUploadReporteErp}
          style={{ display: "none" }}
        />

        <Button
          variant="outline-secondary"
          onClick={() => document.getElementById("archivo-erp").click()}
        >
          <BiUpload /> Cargar reporte ERP
        </Button>

        <span className="ms-2 text-muted small">
          {archivoErpNombre || "Sin archivo"}
        </span>
      </Col>

      <Col md={5}>
        <Badge bg="info" className="me-2">
          ERP órdenes: {erpResumen.totalOrdenes}
        </Badge>

        <Badge bg="success" className="me-2">
          Encontradas: {erpResumen.encontradas}
        </Badge>

        <Badge bg="warning" text="dark" className="me-2">
          Anuladas: {erpResumen.anuladasEncontradas}
        </Badge>
      </Col>
    </Row>
  </div>
  </Container>

   <Container fluid className="mb-3">
                <Row>
                  <Col>
                    <Badge bg="primary" className="me-2">
                      Cargadas: {ordenesExcel.length}
                    </Badge>

                    <Badge bg={erroresArchivo.length ? "danger" : "success"}>
                      Errores archivo: {erroresArchivo.length}
                    </Badge>

                    <Badge bg="secondary" className="ms-2">
                      Resultados: {orders.length}
                    </Badge>

                    <Badge bg="success" className="ms-2">
                      Solucionadas:{" "}
                      {Object.values(ordenesSeleccionadas).filter(Boolean).length}
                    </Badge>
                  </Col>
                </Row>
   </Container>

    {erroresArchivo.length > 0 && (
      <Container fluid className="mb-3">
        <div className="alert alert-warning">
          <b>Errores encontrados:</b>
          <ul className="mb-0">
            {erroresArchivo.slice(0, 20).map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        </div>
      </Container>
    )}
     {tipoConsulta === "masiva" && (
        <Container fluid className="mb-2">
          <div className="border rounded p-2 bg-light">
            <Row className="align-items-end g-2">
              <Col md={3}>
                {/* <Form.Label className="mb-1">Filtrar No Orden</Form.Label> */}
                <Form.Control
                  size="sm"
                  type="text"
                  placeholder="Buscar orden..."
                  value={filtroNoOrden}
                  onChange={(e) => setFiltroNoOrden(e.target.value)}
                />
              </Col>

              <Col md={3}>
                {/* <Form.Label className="mb-1">Estado Backend</Form.Label> */}
                <Form.Select
                  size="sm"
                  value={filtroEstadoBackend}
                  onChange={(e) => setFiltroEstadoBackend(e.target.value)}
                >
                  <option value="">Todos</option>
                  {estadosBackendDisponibles.map((estado) => (
                    <option key={estado} value={estado}>
                      {estado}
                    </option>
                  ))}
                </Form.Select>
              </Col>

              <Col md={2}>
                <Button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => {
                    setFiltroNoOrden("");
                    setFiltroEstadoBackend("");
                  }}
                >
                  Limpiar filtros
                </Button>
              </Col>

              <Col md={4}>
                <Badge bg="dark">
                  Mostrando: {ordersFiltradas.length} de {orders.length}
                </Badge>
              </Col>
            </Row>
          </div>
        </Container>
        )}

  <div className="container-fluid mb-3">
    <div className="row">
      <div className="table-responsive">
       
            <Table striped bordered hover className="custom-table table">
              <thead className="table-header">
                <tr>
                  <th>Solucionado</th>
                  <th>Tienda</th>
                  <th>Serie</th>
                  <th>Id Shopify</th>
                  <th>No Orden</th>
                  <th>Tipo de envío</th>
                  <th>Contacto</th>
                  <th>DNI cliente</th>
                  <th>Departamento</th>
                  <th>Municipio</th>
                  <th>Dirección</th>
                  <th>Guía</th>
                  <th>Estado Backend</th>
                  <th>Msj</th>
                  <th>Opciones</th>
                </tr>
              </thead>

              <tbody>
                {/* {orders.map((orderItem, index) => ( */}
                  {ordersFiltradas.map((orderItem, index) => (
                  <tr
                    key={`${orderItem.serie}-${orderItem.order_number}-${index}`}
                    className={
                      isOrdenSeleccionada(orderItem) ? "table-success" : ""
                    }
                  >
                    <td className="text-center">
                      <Form.Check
                        type="checkbox"
                        checked={isOrdenSeleccionada(orderItem)}
                        onChange={() => toggleOrdenSeleccionada(orderItem)}
                      />

                      {orderItem.existeEnErp ? (
                        <Badge
                          bg={orderItem.erpAnulada ? "warning" : "info"}
                          text={orderItem.erpAnulada ? "dark" : undefined}
                          className="mt-1"
                        >
                          {orderItem.erpAnulada ? "ERP ANUL" : "ERP"}
                        </Badge>
                      ) : null}
                    </td>

                    <td>{orderItem.tienda}</td>
                    <td>{orderItem.serie}</td>
                    <td>
                      {orderItem.data?.order_id ? (
                        <a
                          href={`https://admin.shopify.com/store/${orderItem.slug}/orders/${orderItem.data.order_id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "#0d6efd",
                            fontWeight: "bold",
                            textDecoration: "none",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                          title="Abrir orden en Shopify Admin"
                        >
                          {orderItem.data.order_id}
                          <BiLinkExternal size={14} />
                        </a>
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td>
                      <b>{orderItem.order_number}</b>
                    </td>
                    <td>{orderItem.data?.tipo_envio}</td>
                    <td>{orderItem.data?.contact}</td>
                    <td>{orderItem.data?.contactDni}</td>
                    <td>{orderItem.data?.departamento}</td>
                    <td>{orderItem.data?.municipio}</td>
                    <td>{orderItem.data?.direccion}</td>
                    <td>{orderItem.data?.tracking_code}</td>
                    <td>
                      <Badge
                        pill
                        bg={statusColor[orderItem.data?.isError] || "secondary"}
                        text="dark"
                      >
                        {orderItem.data?.nombre_status
                          ? orderItem.data.nombre_status.toUpperCase()
                          : ""}
                      </Badge>
                    </td>
                    <td>{orderItem.data?.msg_error}</td>
                    <td>
                      <Dropdown>
                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                          <BiMenu />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          {orderItem.data?.status_id == 5 &&
                          orderItem.data?.isError ? (
                            <Dropdown.Item
                              onClick={() => handleShow(orderItem)}
                            >
                              Registrar identificación cliente
                            </Dropdown.Item>
                          ) : null}

                          {orderItem.data?.status_id == 1 ? (
                            <Dropdown.Item
                              onClick={() =>
                                handleShowActualizarUbicacion(orderItem)
                              }
                            >
                              Actualizar ciudad de destino
                            </Dropdown.Item>
                          ) : null}

                          {orderItem.data?.status_id == 10 ||
                          orderItem.data?.status_id == 11 ? (
                            <Dropdown.Item
                              onClick={() =>
                                handleCargarOrdenBackend(orderItem)
                              }
                            >
                              Cargar orden al backend
                            </Dropdown.Item>
                          ) : null}

                          {(orderItem.data?.status_id == 2 || hasStatus7or8) &&
                          orderItem.data?.status_id != 8 &&
                          orderItem.data?.status_id != 7 ? (
                            <Dropdown.Item
                              onClick={() =>
                                handleRestartOrderDescargada(orderItem)
                              }
                            >
                              Confirmar solución
                            </Dropdown.Item>
                          ) : null}

                          {orderItem.data?.status_id == 8 ? (
                            <Dropdown.Item
                              onClick={() =>
                                handleRestartOrderDescargada(orderItem)
                              }
                            >
                              Restablecer proceso de integración
                            </Dropdown.Item>
                          ) : null}
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                ))}

                {/* {orders.length === 0 && ( */}
                {ordersFiltradas.length === 0 && (
                  <tr>
                    <td colSpan="15" className="text-center">
                      No hay resultados para mostrar.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </div>

      <RegistrarIdentificacion
        show={show}
        handleClose={handleClose}
        order={order}
        tienda={order?.gbl_id}
        busqueda={() => actualizarFilaOrden(order)}
      />

      <RegistrarGuia show={showguia} handleClose={handleCloseguia} />

      <RegistrarUbicacionColombia
        show={showUbicacionCO}
        handleClose={handleCloseUbicacionCO}
        order={order}
        tienda={order?.gbl_id}
        busqueda={() => actualizarFilaOrden(order)}
      />

      <RegistrarUbicacionPanama
        show={showUbicacionPA}
        handleClose={handleCloseUbicacionPA}
        order={order}
        tienda={order?.gbl_id}
        busqueda={() => actualizarFilaOrden(order)}
      />
    </>
  );
}

export default GestionarOrdenesMasivas;